import i18next from 'i18next';
import store from '../store';
import LodashUtils from './lodashUtils';
import { PROJECT_HASH_PARAM } from '../constants/formParams';
import queryString from 'query-string';
import { getLocalStorageItem } from '../utils/sessionUtils';
import { PROJECT_REGISTRATION_KEY } from '../constants/sessionStorage';
import { PATHS_WITH_PARAMS } from './paths';
import BASE_PATH from '../constants/path';

export const getLocalStorageValuesKey = (formDefId) => {
  return `form-${formDefId}-values`;
};

export const getCurrentLanguage = () => store.getState().app.language;

export const getAccountRegisterUrl = () =>
  store.getState().app.accountRegisterUrl;

export const getTranslation = (languages = {}, key = '') => {
  if (typeof languages === 'string') {
    return i18next.t(languages);
  }

  const currentLanguage = getCurrentLanguage();
  const availableLanguages = Object.keys(languages);
  if (availableLanguages.includes(currentLanguage)) {
    return key ? languages[currentLanguage][key] : languages[currentLanguage];
  }
  return key ? null : languages[availableLanguages[0]];
};

export const isKeyExist = (languageObject = undefined, useTranslate = true) => {
  if (languageObject === undefined) return '';

  if (useTranslate) return getTranslation(languageObject);
  return languageObject;
};

export const getMatchingOptionsLabels = (arr1, arr2) => {
  const matchingLabels = [];

  (arr1 ?? []).forEach((obj) => {
    if (arr2.includes(obj.value)) {
      matchingLabels.push(obj.label);
    }
  });

  return matchingLabels;
};

export const getFormconfigElements = (data, fieldCode) => {
  return LodashUtils.find(LodashUtils.flatMap(data.sections, 'elements'), {
    fieldCode,
  });
};

export const hasAllTruthyValues = (obj) => {
  return LodashUtils.every(obj, Boolean);
};

export const getURLSearchParams = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  return params;
};

export const isQueryParamsExist = () => {
  const urlParams = new URLSearchParams(window.location.search);

  if ([...urlParams].length > 0) {
    return true;
  } else {
    return false;
  }
};

export const countQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.size;
};

export const getRegistrationUrl = () => {
  return (
    getLocalStorageItem(PROJECT_REGISTRATION_KEY) ??
    PATHS_WITH_PARAMS.account_register
  );
};

export const getTotalRowCount = (data) => {
  return LodashUtils.get(data, 'totalSize', 0);
};

export const isExistInArray = (array, value) => {
  return array.includes(value);
};

export const getSplittedText = (text, separator = '|') => {
  if (!text) return [];
  return text.split(separator).map((label) => label.trim());
};

// export const getCurrentPathname = (trim = true) => {
//   const queryParam = window.location.search;
//   const path = trim
//     ? window.location.pathname.slice(1)
//     : window.location.pathname;
//   return queryParam ? `${path}${queryParam}` : path;
// };

export const getCurrentPathname = (trim = true) => {
  const queryParam = window.location.search;
  let path = trim
    ? window.location.pathname.slice(1)
    : window.location.pathname;
  if (path.startsWith('accreditationform/')) {
    path = path.replace(/^accreditationform\//, '');
  }
  return queryParam ? `${path}${queryParam}` : path;
};

export const getProjectTokenFromUrl = () => {
  return queryString.parse(window.location.search, { decode: false })[
    PROJECT_HASH_PARAM
  ];
};

export const isOnlyProjectTokenExistFromUrl = () => {
  return getProjectTokenFromUrl() && countQueryParams() === 1;
};
